import { createFileRoute } from '@tanstack/react-router';
import { getPageWithContent } from '@/services/docs';
import DocsGroupPage, { DocsGroupPageLoading } from '@/components/Docs/DocsGroupPage';

export const Route = createFileRoute('/developers/$section/$slug')({
  loader: async ({ params }) =>
    getPageWithContent(params.section, params.slug, 'developers'),
  pendingComponent: DocsGroupPageLoading,
  component: DevelopersPage,
});

function DevelopersPage() {
  const page = Route.useLoaderData();
  return <DocsGroupPage page={page} />;
}
